<template>
    <div id="container-dialogue">
        <div class="container-mauvaise-reponse w-100 position-absolute">
            <!-- modal mauvaise réponse -->
            <!-- <modal-mauvaise-reponse v-if="showModal" @close="showModal = false" /> -->
        </div>
        <div class="row h-100 d-flex justify-content-between flex-column m-auto flex-nowrap">
            <!-- Dialogue interlocuteur -->
            <div class="col-12 position-relative d-flex align-items-start" id="col-dialogue">
                <div v-if="dialogue" id="dialogue-interlocuteur" class="text-start bottom-0">
                    <!-- Titre -->
                    <div
                        v-if="dialogue?.titre"
                        id="titre-dialogue"
                        v-html="dialogue.titre">
                    </div>
                    <!-- Dialogue -->
                    <div
                        v-if="dialogue?.texte"
                        id="dialogue-texte"
                        class="show-text-slow"
                        v-html="dialogue.texte">
                    </div>
                </div>
            </div>
            <!-- Réponses joueur -->
            <div class="col-12 position-relative flex-column" id="col-reponses">
                <div
                    class="hidden"
                    :class="{ 'padding-bottom': mission.parametres?.is_tutoriel }"
                    id="col-reponses-consigne"
                >
                    <!-- Consigne -->
                    <div v-if="dialogue?.consigne" id="consigne-dialogue" v-html="dialogue.consigne"></div>
        
                    <!-- Row réponses par défaut -->
                    <reponse-component
                        v-if="dialogue?.type === null"
                        :list_reponses="list_reponses"
                        :csrfTokenName="csrfTokenName"
                        :csrfTokenValue="csrfTokenValue"
                    />
        
                    <!-- Bouton réponses pour QCM -->
                    <reponse-qcm-component
                        v-if="dialogue?.type === 'qcm'"
                        :list_reponses="list_reponses"
                        :selected_reponses="selected_reponses"
                        :csrfTokenName="csrfTokenName"
                        :csrfTokenValue="csrfTokenValue"
                    />
                </div>
                <div :class="{ 'd-flex': true, 'dialogue-footer': mission.parametres?.is_tutoriel }">
                    <div id="logo-client">
                        <img src="images/accueil/logo.svg" />
                    </div>
                    <div v-if="!mission.parametres?.is_tutoriel" class="container-score-annee">
                        <progress-bar-component
                            :joueur_list_scores="joueur_list_scores"
                        />
                    </div>
                </div>
            </div>
        </div>
        <!-- Personnage -->
        <img
            v-if="personnage?.image"
            class="personnage position-absolute"
            :src="'/images/personnages/' + personnage.image"
        />
    </div>
</template>
  
<script>
    /* eslint-disable */ 
    // import ModalMauvaiseReponse from './ModalMauvaiseReponse.vue';
    import ReponseComponent from './ReponseComponent.vue';
    import ReponseQcmComponent from './ReponseQcmComponent.vue';
    import ProgressBarComponent from './ProgressBarComponent.vue';
  
    export default {
        name: 'DialogueComponent',
        components: {
            // ModalMauvaiseReponse,
            ReponseComponent,
            ReponseQcmComponent,
            ProgressBarComponent,
        },
        props: {
            dialogue: {
                type: Object,  
                default: null,
            },
            list_reponses: {
                type: Array,
                default: () => [],
            },
            personnage: {
                type: Object,
                default: null,
            },
            mission: {
                type: Object,
                required: true
            },
            joueur_list_scores: {
                type: Object,
                required: true
            },
            csrfTokenName: {
                type: String,
                required: true
            },
            csrfTokenValue: {
                type: String,
                required: true
            },
            selected_reponses: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
            };
        },
        mounted() {
            this.animation_show_text_slow();
            this.check_reponses_animation( this.list_reponses );
        },
        watch: {
            // On change on list_reponses data
            list_reponses( new_list_reponses ) {
                // check if start animation to do
                this.check_reponses_animation( new_list_reponses )
            },
            dialogue() {
                // Wait DOM update to animate text
                this.$nextTick(() => {
                    this.animation_show_text_slow();
                });
            }
        },
        methods: {
            // Check if reponse has start animation to do
            check_reponses_animation( list_reponses ) {
                list_reponses.forEach( reponse => {
                    // check if load is start
                    if ( reponse.parametres?.animation?.load === 'start' ) {        
                        let methode_animation = reponse.parametres.animation.fonction ?? null;
                        // call the dynamic animation when the dom is ready
                        $(function(){
                            window[ methode_animation ]( reponse.id_reponse )
                        })
                    }
                });
            },
            // Lance l'animation show_text_slow lors d'un changement de l'état du dialogue
            animation_show_text_slow() {
                // Masquer les réponses au début de chaque animation
                const $reponses = $('#col-reponses-consigne').css('opacity', '0').addClass('hidden');

                // Get and hide the texts immediatly
                let $texts = $('.show-text-slow');
                $texts.css('opacity', '0');

                // When dom ready
                $(function(){
                    // Afficher les réponses après l'animation du texte
                    if ( $texts.length ) {
                        let totalDelay = show_text_slow();
                        // Afficher les réponses après l'animation du texte
                        setTimeout(() => {
                            $reponses.css('opacity', 1).removeClass('hidden');
                        }, totalDelay + 300);
                    } else {
                        $reponses.css('opacity', 1).removeClass('hidden');
                    }
                })
            },
        },
    };
</script>